<template>
  <div class="left-sidebar">
    <div class="left-sidebar__top">
      <div class="aspace-between aalign-center">
        <!-- <img src="/img/logos/alfathedulogo.svg" alt="" /> -->
        <img src="/img/logos/alfathbelajarlogo.svg" alt="" />
        
        <img
          src="/img/icons/menu.svg"
          alt=""
          class="c-pointer"
          @click="$emit('menuClick')"
        />
      </div>
    </div>
    <div class="left-sidebar__bottom">
      <div class="menu mt-3 mb-4" v-if="isLoggedIn && content.length+quiz.length > 0 && $route.name != 'login'">
        <div class="menu__level1">
          <template>
            <div
              class="menu__item"
              @click="expanded = !expanded"
            >
              <div class="aalign-center">
                <fa-icon icon="play-circle" class="mr-1"></fa-icon>
                <span class="mr-2">KONTEN BELAJAR</span>
                <div
                  class="arrow-right"
                  :class="{ 'rotate-90': expanded }"
                  style="right: 7px;"
                ></div>
              </div>
            </div>
           
            <b-collapse v-model="expanded">
              <div
                class="menu__level3"
                v-for="(item, k) in content"
                :key="k"
                style="margin-bottom: 10px"
              >
                <b-link
                  :to="'/class/'+section.id+'/'+item.type+'/'+item.id"
                  class="menu__item"
                  v-on:click.native="handleLinkClick"
                  style="padding: 5px 22px 5px 30px; font-size: 9pt"
                >
                  <fa-icon :icon="item.type=='video'||item.type=='youtube' ? ['far', 'play-circle'] : ['far', 'copy']" class="mr-1">
                  </fa-icon>
                  {{ item.name }} <br />
                  <div class="menu__info" style="padding: 10px 0px">
                    <fa-icon v-if="item.type=='video' || item.type=='youtube'" icon="clock" class="mr-1"></fa-icon>
                    {{ item.duration }}
                  </div>

                  <img
                    src="/img/icons/free.svg"
                    alt="free"
                    class="menu__free"
                    v-if="!item.pay"
                  />
                </b-link>
              </div>
            </b-collapse>
          </template>
        </div>
        <div class="menu__level1" v-if="quiz.length > 0" v-for="qz in quiz">
          <b-link
            class="menu__item"
            @click="goToQuiz(qz)"
          >
            <fa-icon icon="check-square" class="mr-1"></fa-icon>
            QUIZ {{qz.name}}
          </b-link>
        </div>
      </div>
      <div class="menu mt-3 mb-4" v-if="false">
        <div class="menu__level1" v-for="(menuItem, i) in menuItems" :key="i">
          <b-link
            class="menu__item"
            
            v-if="menuItem.type === 'link'"
            
          >
            <fa-icon :icon="menuItem.icon" class="mr-1"></fa-icon>
            {{ menuItem.text }}
          </b-link>

          <template v-else>
            <div
              class="menu__item"
              
            >
              <fa-icon :icon="menuItem.icon" class="mr-1"></fa-icon>
              {{ menuItem.text }}
            </div>
          </template>
        </div>
      </div>
    </div>
    <b-modal v-model="confirmModal" hide-footer hide-header centered>
      <modal-close @click="confirmModal = false"></modal-close>
      <div class="p-4 text-center">
        <img src="/img/icons/mulai-exam.svg" alt="" />
        <h3 class="text-center mt-3">Mulai QUIZ</h3>
        <p>Apakah kamu yakin untuk memulai quiz sekarang?</p>
        <my-button class="mr-2 mt-4" type="fill-blue" @click="handleYaClick">
          Ya
        </my-button>
        <my-button @click="confirmModal = false">
          Batal
        </my-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { menuItems } from "../data/menuItems";
import { mapGetters } from "vuex";
import * as types from "../store/types";

export default {
  data() {
    return {
      menuItems, 
      confirmModal: false,
      currQuiz: null,
      expanded: true
    };
  },
  methods: {
    handleLinkClick() {
      if (window.innerWidth < 768) {
        this.$emit("menuClick");
      }
    }, 
    handleYaClick() {
      if(this.currQuiz) {
        this.confirmModal = false
        this.$router.push('/class/'+this.section.id+'/quiz/'+this.currQuiz.id)
      }
    },
    goToQuiz(qz) {
      this.currQuiz = qz
      this.confirmModal = true
    }
  },
  computed: {
    ...mapGetters({
      isLoggedIn: types.IS_LOGGED_IN,
      content: types.CONTENT,
      quiz: types.QUIZ, 
      section: types.SECTION
    })
  }
};
</script>

<style>
.left-sidebar {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.left-sidebar__top {
  height: 87px;
  background-image: url("/img/backgrounds/ornament.svg");
  background-size: 100% 100%;
  padding: 20px 27px;
}

.left-sidebar__bottom {
  overflow-y: auto;
  height: calc(100vh - 155px);
  padding: 0 6px;
}

.menu__level1 .menu__item {
  font-size: 14px;
  font-weight: bold;
  line-height: 1.29;
  color: #009feb;
  padding: 17px 27px;
  cursor: pointer;
  display: block;
}

.menu__level1 .menu__item:hover {
  text-decoration: none;
}

.menu__level1 .router-link-active {
  background-color: #e2f6ff;
  border-top: 1px solid #009feb;
  border-bottom: 1px solid #009feb;
}

.menu__level2 .menu__item {
  font-size: 14px;
  color: #0c2846;
  padding: 13px 50px;
  display: block;
}

.menu__level2 .router-link-active {
  background-color: #e2f6ff;
  border-top: 1px solid #009feb;
  border-bottom: 1px solid #009feb;
}

.menu__level3 .menu__item {
  color: #0c2846;
  font-weight: normal;
  border-top: 1px solid #fff;
  border-bottom: 1px solid #fff;
  position: relative;
  padding: 13px 50px;
}

.menu__free {
  position: absolute;
  right: 7px;
  top: 14px;
  z-index: 999;
}

.menu__level3 .menu__item:hover {
  background-color: #e2f6ff;
}

.menu__level3 .router-link-active {
  background-color: #e2f6ff;
  border-top: 1px solid #009feb;
  border-bottom: 1px solid #009feb;
}

.menu__level3 .menu__info {
  font-size: 11px;
  color: #b4b4b4;
  padding: 5px 22px;
  padding-bottom: 0;
  line-height: 1;
}
</style>
